"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMarkdownOptions = exports.getDateDiff = void 0;

var getDateDiff = function getDateDiff(date) {
  if (!date) {
    return;
  }

  var now = new Date().getTime();
  var dateDiff = now - date; // if datediff is 0, return 1 so we can do "!datediff"

  return Math.max(dateDiff, 1);
};

exports.getDateDiff = getDateDiff;
var defaultMarkdownOptions = {
  overrides: {
    iframe: function iframe() {
      return null;
    }
  }
};
exports.defaultMarkdownOptions = defaultMarkdownOptions;